import React from "react";
import Components from "../../components";

const ProductDetail = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.ProductDetail
        id="product-detail"
        label="Product Detail"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default ProductDetail;
